import { useState as a, useEffect as r } from "react";
function m(t, o) {
  const [e, n] = a(!1), [d, u] = a(!1), s = (c) => document.createRange().createContextualFragment(c);
  return r(() => {
    t && !e && (n(!0), document.head.append(s(t))), o && !e && (u(!0), document.head.append(s(o)));
  }, [t, o, e, d]), {
    isHeadCodeLoaded: e,
    isBodyCodeLoaded: d
  };
}
export {
  m as useCustomCodes
};
//# sourceMappingURL=useCustomCodes.js.map
